import { createSlice } from '@reduxjs/toolkit';
import {
  getInternshipInfoThunk,
  getInternshipListThunk,
  getInternshipMetaThunk,
  getInternshipPeopleListThunk,
} from './Internship.thunk';

export const internshipSlice = createSlice({
  name: 'internships',
  initialState: {
    list: {
      items: [],
      loading: true,
      pagination: {},
    },
    people: {
      items: [],
      loading: true,
      pagination: {},
    },
    selected: {
      item: undefined,
      loading: false,
    },
    meta: {
      items: undefined,
      loading: true,
    },
  },
  reducers: {
    resetInternshipListAction: state => ({
      ...state,
      list: {
        ...state.list,
        items: [],
        pagination: {},
      },
    }),
    getInternshipListPeople: (state, { payload }) => {
      state.people.items = payload.data;
      state.people.pagination = {
        currentPage: payload.pagination.current_page,
        lastPage: payload.pagination.last_page,
        total: payload.pagination.total,
      };
      state.people.loading = false;
    },
    resetInternshipSelectedAction: state => ({
      ...state,
      selected: {
        ...state.selected,
        item: undefined,
      },
    }),
    resetInternshipSelectedPeopleAction: state => ({
      ...state,
      people: {
        ...state.people,
        items: [],
        pagination: {},
        loading: false,
      },
    }),
    setInternshipSelectedAction: (state, action) => ({
      ...state,
      selected: {
        ...state.selected,
        item: action.payload,
        loading: false,
      },
    }),
  },
  extraReducers: builder => {
    // Start Internship Meta
    builder.addCase(getInternshipMetaThunk.pending, state => {
      state.meta = { ...state.meta, loading: true };
    });
    builder.addCase(getInternshipMetaThunk.fulfilled, (state, action) => {
      state.meta = {
        ...state.meta,
        items: { ...action.payload },
        loading: false,
      };
    });
    builder.addCase(getInternshipMetaThunk.rejected, () => {
      // state.meta = { ...state.meta, loading: false };
    });
    // End Internship meta
    // Start Internships List
    builder.addCase(getInternshipListThunk.pending, state => {
      state.list = { ...state.list, loading: true };
    });
    builder.addCase(getInternshipListThunk.fulfilled, (state, action) => {
      const { data, pagination: _pagination } = action.payload;
      const pagination = {
        currentPage: _pagination.current_page,
        lastPage: _pagination.last_page,
        total: _pagination.total,
      };
      state.list = { ...state.list, items: data, pagination, loading: false };
    });
    builder.addCase(getInternshipListThunk.rejected, () => {
      // state.list = { ...state.list, loading: false };
    });
    // End Internships List
    // Start Internships People List
    builder.addCase(getInternshipPeopleListThunk.pending, state => {
      state.people = { ...state.people, loading: true };
    });
    builder.addCase(getInternshipPeopleListThunk.fulfilled, (state, action) => {
      const { data, pagination: _pagination } = action.payload;
      const pagination = {
        currentPage: _pagination.current_page,
        lastPage: _pagination.last_page,
        total: _pagination.total,
      };
      state.people = {
        ...state.people,
        items: data,
        pagination,
        loading: false,
      };
    });
    builder.addCase(getInternshipPeopleListThunk.rejected, () => {
      // state.people = { ...state.people, loading: false };
    });
    // End Internships People List
    // Start Internship Info
    builder.addCase(getInternshipInfoThunk.pending, state => {
      state.selected = { ...state.selected, item: undefined, loading: true };
    });
    builder.addCase(getInternshipInfoThunk.fulfilled, (state, action) => {
      state.selected = {
        ...state.selected,
        item: action.payload,
        loading: false,
      };
    });
    builder.addCase(getInternshipInfoThunk.rejected, () => {
      // state.selected = { ...state.selected, loading: true };
    });
    // End Internship Info
  },
});

export const {
  resetInternshipSelectedAction,
  resetInternshipSelectedPeopleAction,
  getInternshipListPeople,
} = internshipSlice.actions;

export const getInternshipsMeta = (state: any) => state.internship.meta;
export const getInternshipsList = (state: any) => state.internship.list;
export const getInternshipSelected = (state: any) => state.internship.selected;
export const getInternshipPeopleList = (state: any) => state.internship.people;

export default internshipSlice.reducer;
